/**
 * Backend base URL from REACT_APP_API_URL.
 * Bare hostnames get https:// so fetch/axios don't treat them as paths on localhost.
 * On HTTPS pages (e.g. Vercel), upgrades http:// → https:// to avoid mixed-content blocks.
 */
function normalizeApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URL;
  if (raw == null || typeof raw !== "string") {
    return raw;
  }
  let trimmed = raw.trim().replace(/\/$/, "");
  if (!trimmed) return trimmed;
  if (!/^https?:\/\//i.test(trimmed)) {
    trimmed = `https://${trimmed}`;
  }
  if (
    typeof window !== "undefined" &&
    window.location &&
    window.location.protocol === "https:" &&
    trimmed.startsWith("http://")
  ) {
    return `https://${trimmed.slice("http://".length)}`;
  }
  return trimmed;
}

const API_BASE_URL = normalizeApiBaseUrl();

export default API_BASE_URL;
